import {
  ChangeDetectionStrategy,
  Component,
  computed,
  HostBinding,
  input,
  OnInit,
  output,
  signal,
} from '@angular/core';
import { LookupKeys } from '@ag-common-lib/lib/models/crm/lookup.model';
import {
  POLICY_VERSION_CHANGE_LOOKUP,
  PolicyVersionChangeKey,
} from 'ag-common-svc/lib/components/policy-version-form/policy-version.model';
import { INITIAL_VERSION } from '@ag-common-lib/lib/models/utils/user-agreement-management.model';

@Component({
  selector: 'ag-shr-policy-version-form',
  templateUrl: './policy-version-form.component.html',
  styleUrl: './policy-version-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PolicyVersionFormComponent implements OnInit {
  @HostBinding('class') protected className = 'policy-version-form';

  inProgress = input<boolean>();
  lastPublishedVersion = input.required<string>(); // last version from subversions or from master versions
  fileVersionChanged = output<string>();

  selectedVersionSig = signal<string>(PolicyVersionChangeKey.minor);
  fileVersionSig = computed(() => {
    return this.lastPublishedVersion() ?? INITIAL_VERSION;
  })

  changedVersionNumberSig = computed(() => {
    const selectedVersionType = this.selectedVersionSig();
    const fileVersion = this.fileVersionSig();

    const parts = fileVersion.split('.').map(num => parseInt(num, 10));
    if (parts.length !== 3 || parts.some(isNaN)) {
      return fileVersion;
    }

    switch (selectedVersionType) {
      case 'major':
        parts[0]++;
        parts[1] = 0;
        parts[2] = 0;
        break;
      case 'middle':
        parts[1]++;
        parts[2] = 0;
        break;
      case 'minor':
        parts[2]++;
        break;
    }
    return parts.join('.');
  });

  protected readonly LookupKeys = LookupKeys;
  protected readonly versionChangeLookup = POLICY_VERSION_CHANGE_LOOKUP;

  ngOnInit(): void {
    this.fileVersionChanged.emit(this.changedVersionNumberSig());
  }

  onVersionChange = event => {
    const value = event?.value ?? PolicyVersionChangeKey.minor;
    this.selectedVersionSig.set(value);
    this.fileVersionChanged.emit(this.changedVersionNumberSig());
  };
}
